import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [isOnAir, setIsOnAir] = useState(false);

  useEffect(() => {
    const checkOnAirStatus = () => {
      const now = new Date();
      const jstOffset = 9 * 60;
      const utcMinutes = now.getUTCHours() * 60 + now.getUTCMinutes();
      const jstMinutes = utcMinutes + jstOffset;
      const jstHours = Math.floor((jstMinutes % 1440) / 60);
      const jstMins = jstMinutes % 60;
      
      const jstDay = new Date(now.getTime() + jstOffset * 60 * 1000).getUTCDay();
      
      const isTuesday = jstDay === 2;
      const isWithinTime = (jstHours === 18 && jstMins >= 30) || (jstHours === 19 && jstMins === 0);
      
      setIsOnAir(isTuesday && isWithinTime);
    };

    checkOnAirStatus();
    const interval = setInterval(checkOnAirStatus, 60000);
    
    return () => clearInterval(interval);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/f493cbe5c2084134677121347fdba237/4488d83fb6cdf2f15ac958df5e61d14a.jpeg"
          alt="Radio Studio Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1628]/70 via-[#0a1628]/50 to-[#0a1628]/90"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        {isOnAir && (
          <div className="mb-8 animate-pulse">
            <div className="inline-flex items-center gap-3 bg-[#ff1493]/20 backdrop-blur-sm px-6 py-3 rounded-full border-2 border-[#ff1493]">
              <div className="w-3 h-3 bg-[#ff1493] rounded-full animate-ping"></div>
              <span className="text-[#ff1493] font-bold text-sm md:text-base whitespace-nowrap">ON AIR</span>
            </div>
          </div>
        )}

        <img 
          src="https://static.readdy.ai/image/f493cbe5c2084134677121347fdba237/214be233785e39ebb6795040f74f7c21.png" 
          alt="Windie's Mania SHABADABA Logo" 
          className="w-32 h-32 md:w-40 md:h-40 object-contain mx-auto mb-6"
        />

        <h2 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Windie's Mania<br />
          <span className="text-[#ff1493]">SHABADABA</span>
        </h2>

        <p className="text-xl md:text-2xl text-[#ffd700] mb-4 font-medium">
          インディーズカルチャーを届けるラジオ番組
        </p>

        <p className="text-lg md:text-xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          小劇団、インディーズ歌手、自主映画など<br className="md:hidden" />
          マイナーだけど魅力的なコンテンツを紹介
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection('listen')}
            className="bg-[#ff1493] text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-[#ff69b4] transition-all duration-300 shadow-lg hover:shadow-[#ff1493]/50 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-radio-line mr-2"></i>
            番組を聴く
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-white/20 transition-all duration-300 border-2 border-white/30 whitespace-nowrap cursor-pointer"
          >
            番組について
          </button>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-8 text-white">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 flex items-center justify-center bg-[#ff1493]/20 rounded-full">
              <i className="ri-calendar-line text-2xl text-[#ff1493]"></i>
            </div>
            <div className="text-left">
              <p className="text-sm text-white/70 whitespace-nowrap">放送日時</p>
              <p className="font-bold text-lg whitespace-nowrap">毎週火曜 18:30〜</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 flex items-center justify-center bg-[#ffd700]/20 rounded-full">
              <i className="ri-radio-2-line text-2xl text-[#ffd700]"></i>
            </div>
            <div className="text-left">
              <p className="text-sm text-white/70 whitespace-nowrap">放送局</p>
              <p className="font-bold text-lg whitespace-nowrap">コミュニティFM 83.6MHz</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer" onClick={() => scrollToSection('about')}>
        <i className="ri-arrow-down-line text-4xl text-white/50"></i>
      </div>
    </section>
  );
}
